import { render } from "./BrandLogoTwo.vue?vue&type=template&id=c2d4aaae"
import script from "./BrandLogoTwo.vue?vue&type=script&lang=js"
export * from "./BrandLogoTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__